
import {Vue, Component, Prop, Mixins} from 'vue-property-decorator';
import AktarDetayUstBasliklar from "@/components/infos/raporlama-ofispro/helper-comps/AktarDetayUstBasliklar.vue";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";

@Component({
  components: {AktarDetayUstBasliklar}
})
export default class AktarDetay extends Mixins(ObjectInputMixin) {
  items: any[] = []


  get messageItems(): any[] {
    if (!this.items[0] || !this.items[0].message) {
      return [];
    }
    return this.items[0].message;
  }

  mounted() {
    this.fetchData().then(() => {

    });
  }

  async fetchData() {
    await this.$http.get('/api/v1/job-details/' + this.$route.params.id).then(res => {
      this.items.push(res.data || res);
    });
  }
}
